import { NewMatchCardSchema } from '@/views/sports/components/NewMatchCard/styles/NewMatchCard.styles';

export const newMatchCardStyles: NewMatchCardSchema = {
  boxWrapper: {
    border: '2px solid',
    borderColor: 'alpha.300',
    borderRadius: 'lg',
    boxShadow:
      '0px 4px 6px 0px rgba(0, 0, 0, 0.3), 0px 0px 0px 2px #20273F inset, 0px 0px 0px 3px rgba(255, 255, 255, 0.2) inset',
    overflow: 'hidden',
    padding: '2px',
  },
  bodyStack: {
    p: 2,
    borderTopRadius: 'base',
    m: '1px',
    mb: '0',
    bgGradient: 'linear(to-b, beta.300, beta.400)',
    fontWeight: 'bold',
  },
  titleHeading: {
    cursor: 'pointer',
    as: 'h5',
    textTransform: 'uppercase',
    textAlign: 'center',
    fontFamily: 'accent',
    fontSize: 'sm',
    fontWeight: 'normal',
    textShadow: '0px 2px 3px rgba(0, 0, 0, 0.24)',
    color: 'white',
  },
  footerFlex: {
    as: 'footer',
    bg: 'beta.400',
    boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 0.10)',
    fontSize: '2xs',
    fontWeight: 'semibold',
    px: '2',
    py: '1',
    borderTop: '1px',
    borderColor: 'blackAlpha.300',
    m: '1px',
    mt: '0',
    borderBottomRadius: 'base',
    alignItems: 'center',
    gap: '1',
  },
  footerStack: {
    direction: 'row',
  },
  footerStackDivider: {
    height: '2.5',
    borderColor: 'blackAlpha.400',
  },
  footerSportNameFlex: {
    align: 'center',
    gap: '1',
    maxW: '85%',
    w: 'fit-content',
    mr: '2',
  },
  footerSportNameIconSvg: {
    color: 'alpha.400',
    fontSize: 'md',
  },
  footerCompetitionNameText: {
    color: 'white',
    fontWeight: 'normal',
    sx: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 'initial',
    },
  },
  footerCountDown: {
    sx: {
      '&&&.state-prior': {
        textTransform: 'uppercase',
      },
    },
    sxWrapper: {
      mr: 'auto',
    },
  },
  footerDuotoneSgmLogo: {
    h: 'auto',
    primaryColor: 'alpha.500',
    secondaryColor: 'beta.600',
    w: '10',
    sx: {
      svg: {
        color: 'alpha.400',
      },
    },
  },
  footerMatchLink: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: 'initial',
    fontWeight: 'normal',
  },
  footerMatchLinkIcon: {
    color: 'alpha.400',
    fontSize: 'md',
  },
};
